import "./HomeSection.css";
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom"
import { useMediaQuery } from "react-responsive";
import ProgressiveImage from "../progressive-image/ProgressiveImage";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "framer-motion";

const HomeSection = ({ Media, index }) => {
    const [showCarousel, setShowCarousel] = useState(false);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const isDesktop = useMediaQuery({ minWidth: 769 });
    const isMobile = useMediaQuery({ maxWidth: 768 });

    //le agregar un espacio al título en cada /n del json
    const renderTitle = (titulo) => {
        const lineas = titulo.split('\n');
        return (
          <div>
            {lineas.map((linea, index) => (
              <p key={index}>{linea.toUpperCase()}</p>
            ))}
          </div>
        );
    };

    //se fija si la imagen debe renderizarse apaisada (className HomeSection__containerLarge)
    const check = (medio, indice) => {
        return indice.includes(medio.id);
    };

    //setteo del carousel -> slick-carousel
    const settings = {
        infinite: true,
        autoplay: true,
        arrows: false,
        swipe: false,
        initialSlide: 0,
        speed: 0,
        autoplaySpeed: 250,
        pauseOnHover: false
    };

    //precarga de imágenes
    useEffect(() => {
        let isActive = true;

        setShowCarousel(false);
        setImagesLoaded(false);

        const preloadImages = () => {
            const imagePromises = Media.imagenes.map((photo) => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.src = photo;
                    img.onload = resolve;
                    img.onerror = reject;
                });
            });

            Promise.all(imagePromises)
                .then(() => {
                    if (isActive) {
                        setImagesLoaded(true);
                    }
                })
                .catch((error) => console.error("Error preloading images:", error));
        };

        preloadImages();

        return () => {
            isActive = false;
        };
    }, [Media.imagenes]);

    return (
        <div>
            {isDesktop && <motion.div
                className="HomeSection"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6 }}
                viewport={{ amount: 0.05 }}
                onMouseEnter={() => setShowCarousel(true)}
                onMouseLeave={() => setShowCarousel(false)}
            >
                {showCarousel ? (
                    <div className={check(Media, index) ? "HomeSection__containerLarge" : "HomeSection__container"}>
                        <Link to={`/video/${Media.ruta}`}>
                        {imagesLoaded && (
                                <Slider {...settings} className="HomeSection__slider">
                                    {Media.imagenes.map((photo, index) => (
                                        <div key={ index }>
                                            <ProgressiveImage
                                                className="HomeSection__image"
                                                src={ photo }
                                                alt={`${Media.titulo} - ${index+1}`}
                                                loading="lazy"
                                                progressive={false}
                                            />
                                        </div>
                                    ))}
                                </Slider>
                            )}
                            {isDesktop && 
                            <div className="HomeSection__text">
                                <p>{renderTitle(Media.titulo)}</p>
                            </div>
                            }
                        </Link>
                    </div>
                ) : (
                    <div className={check(Media, index) ? "HomeSection__containerLarge" : "HomeSection__container"}>
                        <Link to={`/video/${Media.ruta}`}>
                            <div className="HomeSection__slider">
                                <ProgressiveImage
                                    className="HomeSection__image"
                                    src={Media.imagenes[0]}
                                    alt={`${Media.titulo}`}
                                    loading="eager"
                                />
                            </div>
                            {isMobile && 
                            <div className="HomeSection__text">
                                <p>{renderTitle(Media.titulo)}</p>
                            </div>
                            }
                        </Link>
                    </div>
                )}
            </motion.div>}
            {isMobile && <div>
                {showCarousel ? (
                    <div className={check(Media, index) ? "HomeSection__containerLarge" : "HomeSection__container"}>
                        <Link to={`/video/${Media.ruta}`}>
                        {imagesLoaded && (
                                <Slider {...settings} className="HomeSection__slider">
                                    {Media.imagenes.map((photo, index) => (
                                        <div key={ index }>
                                            <ProgressiveImage
                                                className="HomeSection__image"
                                                src={ photo }
                                                alt={`${Media.titulo} - ${index+1}`}
                                                loading="lazy"
                                                progressive={false}
                                            />
                                        </div>
                                    ))}
                                </Slider>
                            )}
                            {isDesktop && 
                            <div className="HomeSection__text">
                                <p>{renderTitle(Media.titulo)}</p>
                            </div>
                            }
                        </Link>
                    </div>
                ) : (
                    <div className={check(Media, index) ? "HomeSection__containerLarge" : "HomeSection__container"}>
                        <Link to={`/video/${Media.ruta}`}>
                            <div className="HomeSection__slider">
                                <ProgressiveImage
                                    className="HomeSection__image"
                                    src={Media.imagenes[0]}
                                    alt={`${Media.titulo}`}
                                    loading="eager"
                                />
                            </div>
                            {isMobile && 
                            <div className="HomeSection__text">
                                <p>{renderTitle(Media.titulo)}</p>
                            </div>
                            }
                        </Link>
                    </div>
                )}
            </div>}
        </div>
    );
};

export default HomeSection;
